import React from 'react'
import './Notfound.css'
import { Link } from 'react-router-dom'


function Notfound() {
  return (
    <section>
      <div className="container notfound__container">
        <h2>Page Not Found</h2>
        <Link to='/' className='btn'>go back home</Link>
      </div>
    </section>
  )
}

export default Notfound